// ── Athena Response Profile ───────────────────────────────────────────────────
// Converts cognitive scores into behavioral instruction set for the LLM.
// Pure function — no side effects, no storage.

export function buildResponseProfile(cognitiveProfile) {
  if (!cognitiveProfile) return null;

  const { scores = {}, traits = [] } = cognitiveProfile;
  const [primary] = traits;

  const vis  = scores.VISUAL         || 0;
  const est  = scores.ESTRUTURADO    || 0;
  const conv = scores.CONVERSACIONAL || 0;
  const prat = scores['PRÁTICO']     || 0;

  return {
    communicationStyle: primary === 'CONVERSACIONAL' ? 'dialogue'
                      : primary === 'PRÁTICO'        ? 'direct'
                      : primary === 'ESTRUTURADO'    ? 'structured'
                      : 'illustrative',

    explanationDepth:   prat >= 8 ? 'shallow'
                      : est  >= 8 ? 'deep'
                      : 'medium',

    exampleFrequency:   vis >= 7 || prat >= 7 ? 'high' : 'normal',

    visualPreference:   vis >= 7 ? 'high' : vis >= 4 ? 'medium' : 'low',

    practicalLevel:     prat >= 7 ? 'high' : 'normal',

    conversationLevel:  conv >= 7 ? 'high' : 'normal',
  };
}
